/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Semanticroles1Inputs */

const de__field_semanticroles1 = /** @type {(inputs: _Field_Semanticroles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rolle`)
};

/**

* @param {_Field_Semanticroles1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_semanticroles1 = /** @type {((inputs?: _Field_Semanticroles1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Semanticroles1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_semanticroles1(inputs)
});
export { _field_semanticroles1 as "_field_semanticRoles" }